import React from 'react';

const EmptyGradientBackground = () => {
  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col items-center">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950 via-black to-gray-900 opacity-95"></div>

      {/* This is where your new content would go, maintaining the background gradient */}
      <main className="relative z-10 flex-grow container mx-auto px-4 py-12 flex flex-col items-center">
        <div className="w-full max-w-4xl mx-auto px-4 py-8 bg-gray-900 rounded-xl shadow-lg border border-gray-700">
          {/* <h2 className="text-3xl font-bold text-white text-center mb-6">
            Empty Component with Gradient
          </h2>
          <p className="text-gray-300 text-center mb-8">
            This component maintains the background gradient from the original Wim Hof Breathing component.
            You can add your own content here.
          </p> */}
        </div>
      </main>

      <footer className="relative z-10 text-center py-6 text-xs text-gray-600 mt-auto">
        {/* You can keep or remove the footer as needed */}
        © {new Date().getFullYear()} Gus • Aguiar. All rights reserved.
      </footer>
    </div>
  );
};

export default EmptyGradientBackground;